import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=13a6395f&scoped=true"
var script = {}
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=13a6395f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6395f",
  null
  
)

export default component.exports